import { render, staticRenderFns } from "./restaurantOwnerForm.vue?vue&type=template&id=56a6d27c&scoped=true&lang=en&"
import script from "./restaurantOwnerForm.vue?vue&type=script&lang=js&"
export * from "./restaurantOwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./restaurantOwnerForm.vue?vue&type=style&index=0&id=56a6d27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a6d27c",
  null
  
)

export default component.exports